import { Form, Input } from 'antd';
import React from 'react';

type shortAnswerProps = {};

const ShortAnswer = (props: shortAnswerProps) => {
  const {} = props;
  return (
    <div>
      <Form.Item
        label="Câu trả lời"
        className="md:ml-[42px] md:!w-[95.5%]"
        name={'traloiNgan'}
        wrapperCol={{ span: 14 }}
        labelCol={{ span: 2 }}
      >
        <Input disabled />
      </Form.Item>
    </div>
  );
};

export default ShortAnswer;
